import {UserDto, CreateStaffUserDto} from "../../../utils/types/user";
import {useMutation} from "react-query";
import Alert from "react-s-alert";
import type {History} from "@remix-run/router";

import {UserService} from "../../../services/UserService";
import {buildResponseErrorMessage} from "../../../services/api/errorHelpers";

export const useEditUser = (user: UserDto, history: Pick<History, "push">) =>
  useMutation((data: CreateStaffUserDto) => UserService.update(user.id, data), {
    onSuccess: () => {
      Alert.success("User was successfully updated.");
      history.push("/admin/users");
    },
    onError: async (resp: any) => {
      Alert.error(
        await buildResponseErrorMessage(
          resp,
          "An error occurs when updating user.",
        ),
      );
    },
  });
